module.exports = __webpack_public_path__ + "static/img/backModel.0242320f.jpg";